import { gql } from 'src/generated/gql';

export const UPDATE_LAB_RESULT = gql(`
  mutation UpdateLabResult($id: ID!, $data: staff_LabResultInput!) {
    staff_updateLabResult(id: $id, data: $data)
  }
`);
